<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-body">
                    <div class="card" style="width: 18rem;">
                        <div>
                            <img :src="src(path)" class="card-img-top" alt="...">
                            <div class="card-body">
                                <h5 class="card-title">{{ name }}</h5>
                                <a href="" class="btn btn-danger" v-on:click.prevent="closeModal">Закрыть</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ContentPictureComponent",
    props: {
        path: String,
        name: String,
        domain: String
    },
    emits: [
        "closePicture"
    ],
    methods: {
        closeModal: function () {
            this.$emit('closePicture', []);
        },
        src: function(path) {
            if (path.indexOf('https') == -1) {
                return `${this.domain}/${path}`;
            }

            return path;
        }
    }
}
</script>

<style scoped>

</style>
